<script>
import Question from '@/components/QuestionItem.vue'
import { previewImage } from '@/assets/js/preview-image'

export default {
  name: 'VoteAnswerQuestion',
  extends: Question,
  data() {
    return {
      showPopup: false
    }
  },
  methods: {
    onShowContent() {
      if(!this.componentName) return
      this.showPopup = true
      this.$nextTick(() => {
        previewImage(this.$refs.popupContent)
      })
    },
    initTitle() {
      let child = this.$refs.title.childNodes[0]
      let el = child
      if (child.nodeType !== 1) {
        el = this.$refs.title
      }
      const nodes = []

      if (this.question.issue.defaultTip) {
        const span = document.createElement('span')
        span.innerText = `【${this.question.issue.defaultTip}】`
        el.appendChild(span)
      }

      if (this.hasAnswerScore) {
        const span = document.createElement('span')
        span.innerHTML = `<span>${this.totalScore} 分</span>`
        span.className = 'text-theme-black-450 px-2 leading-22 rounded-small ml-2'
        el.appendChild(span)
      }
      const title = this.$refs.title
      previewImage(title)
      let note = this.$refs.note
      if (note) {
        this.isOverFlowNote = note.clientHeight < note.scrollHeight
      } else {
        this.isOverFlowNote = false
      }
    }
  }
}
</script>

<template>
  <div class="question-item bg-white box-border px-4 relative" @click="onShowContent">
    <!-- unknown-wrap 只有在量表生效 -->
    <div>
      <div ref="title" class="q-title leading-base break-words" v-html="title"></div>
    </div>
    <div class="q-desc-wrap" :class="[isOverFlowNote ? 'pb-8' : '']">
      <div ref="note" class="q-desc text-medium break-words leading-base pl-5 mt-1" :class="getNoteClass"
           v-if="showNote">
        <div v-html="question.note"></div>
      </div>
      <div v-if="isOverFlowNote" class="operate-btn" @click="isOpenNote = !isOpenNote">
        <span class="text-theme">{{ isOpenNote ? '收起' : '展开' }}</span>
        <span>
            <i :class="isOpenNote ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </span>
      </div>
    </div>
    <template v-if="content.allowPhotoNum && content.allowPhotoNum > 0">
      <adapter-upload-files :content="content" />
    </template>
    <el-drawer
        @click.native.stop
        :visible.sync="showPopup" size="100%">
      <div class="content-wrapper" ref="popupContent">
        <component :is="componentName" :question="question"></component>
      </div>
    </el-drawer>
  </div>
</template>

<style scoped lang="scss">
.content-wrapper {
  width: 800px;
  margin: 0 auto;
  padding: 50px 20px;
}
</style>